import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiSourcedPaginationRequest} from '@webmate-web-core/shared/api/apibase.api';
import {AuthService} from '@webmate-web-core/shared/services/auth.service';
import {MarketplaceItemId} from '@webmate-web-core/shared/types/ids';
import {
    MarketplaceInteractionRecorded,
    MarketplaceInteractionSubmission,
    MarketplaceItem,
    MarketplaceRequest
} from '@webmate-web-core/shared/types/marketplace';

/**
 * HTTP adapter for the Marketplace API. It intentionally contains transport
 * details only; presentation and application logic belongs to MarketplaceService.
 */
@Injectable({
    providedIn: 'root'
})
export class MarketplaceApi {

    constructor(public OAuth2AuthService: AuthService, private http: HttpClient) {
    }

    getPublishedItems$(): Observable<MarketplaceItem[]> {
        return this.http.get<MarketplaceItem[]>('/marketplace/items');
    }

    getPublishedItem$(itemId: MarketplaceItemId): Observable<MarketplaceItem> {
        return this.http.get<MarketplaceItem>(`/marketplace/items/${encodeURIComponent(itemId)}`);
    }

    recordInteraction$(submission: MarketplaceInteractionSubmission): Observable<MarketplaceInteractionRecorded> {
        return this.http.post<MarketplaceInteractionRecorded>('/marketplace/interactions', submission);
    }

    getRequestsForCurrentUser$(limit: number): ApiSourcedPaginationRequest<MarketplaceRequest> {
        return new ApiSourcedPaginationRequest<MarketplaceRequest>(
            '/marketplace/requests',
            this.http,
            {limit: limit.toString()}
        );
    }

    getRequestsForCurrentCustomer$(limit: number): ApiSourcedPaginationRequest<MarketplaceRequest> {
        return new ApiSourcedPaginationRequest<MarketplaceRequest>(
            '/administration/marketplace/requests',
            this.http,
            {limit: limit.toString()}
        );
    }
}
